import React, { FC } from 'react'
import {
  TextField,
  TextFieldProps,
  InputProps,
  InputLabelProps,
  createStyles,
  makeStyles,
} from '@zn-material-ui'

export type ITextFieldProps = TextFieldProps

const CTextField: FC<ITextFieldProps & {
  InputLabeClass?: InputProps['classes']
  InputClass?: InputLabelProps['classes']
}> = props => {
  const { InputLabeClass, InputClass, value, ...textFieldProps } = props
  const classes = useStyles()

  return (
    <TextField
      margin="normal"
      variant="standard"
      value={value}
      InputLabelProps={{
        classes: Object.assign(
          {},
          { root: classes.inputLabel },
          InputLabeClass
        ),
        shrink: true,
      }}
      InputProps={{
        classes: Object.assign(
          {},
          { root: classes.inputText, underline: classes.underline },
          InputClass
        ),
      }}
      {...textFieldProps}
    />
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    inputLabel: {
      fontSize: 20,
      color: '#1F1F1F',
    },
    inputText: {
      fontSize: 18,
      color: '#1F1F1F',
      marginTop: '25px !important',
    },
    underline: {
      transition: 'unset',
      '&:before': {
        borderBottom: '1px solid #E9EBF0 !important',
      },
      '&:after': {
        transition: 'unset',
        borderBottom: 'none',
      },
    },
  })
)

export default CTextField
